import React, { Component } from 'react';
import Card from '../../components/card/Card';
import Input from '../../inputs/input/Input';
import Button from '../../components/button/Button';
import './DrugsPaginatedCard.css';
import history from '../../history';
import mainAPI from '../../api/MainAPI';
import utils from '../../utils/utils';
import CardHeader from '../../components/cardHeader/CardHeader';
import { Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import Label from '../../components/label/Label';
import CreateDrugModal from "../drugCard/createDrugModal/CreateDrugModal";
import {getDrugName} from "../../utils/gramUtils";
import CheckBox from '../../inputs/checkBox/CheckBox';

class DrugsPaginatedCard extends Component {
	static defaultProps = {
		displayNewDrugButton: true,
		pageSize: 20
	};

	constructor(props) {
		super(props);
		this.storageKey = 'drugsPaginatedSortPreference';
		this.currentRequestId = 0;
		this.tableRef = React.createRef();
		this.scrollContainerRef = React.createRef();
		

		this.VALID_ORDER_BY_OPTIONS = {
			'Type': 'drug.type',
			'Code': 'drug.barcode_id',
			'Unit': 'unit.name',
			'Lot': 'drug.lot_number',
			'Last Check': 'dc.created_on',
			'Checked By': 'drug.checked_by_name',
			'Created On': 'drug.created_on',
			'NDC Barcode': 'drug.ndc_barcode',
			'Expires On': 'drug.expiration_date'
		};
		

		const savedSortConfig = (() => {
			try {
				const item = localStorage.getItem(this.storageKey);
				return item ? JSON.parse(item) : { key: 'Type', direction: 'asc' };
			} catch (e) {
				return { key: 'Type', direction: 'asc' };
			}
		})();
		
		this.state = {
			search: '',
			create: false,
			drugs: [],
			loading: false,
			loadingMore: false,
			currentPage: 1,
			totalPages: 1,
			totalCount: 0,
			hasMore: true,
			sortConfig: savedSortConfig
		};
		
		this.refreshingFromUpdate = false;
		

		this.sortTableOptions = null;
		this.savedScrollPosition = undefined;
	}

	_getSortTableOptions = () => {
		return {
			loadSortConfig: () => {
				return this.state.sortConfig;
			},
			onSortConfigSet: (config) => {
				localStorage.setItem(this.storageKey, JSON.stringify(config));
				this.setState({ sortConfig: config, currentPage: 1, drugs: [] }, () => {
					this._loadDrugs(true);
				});
			}
		};
	};

	componentDidMount = () => {
		this._loadDrugs(true);
		// setInterval(() => {this._loadDrugs(true)}, 5000)
	};

	componentDidUpdate = (prevProps) => {
		if (this.refreshingFromUpdate) {
			this.refreshingFromUpdate = false;
			return;
		}
		
		const { filter } = this.props;
		const prevFilter = prevProps.filter || {};
		const currentFilter = filter || {};
		
		const filterChanged = JSON.stringify(prevFilter) !== JSON.stringify(currentFilter);
		
		if (filterChanged && !this.pendingRequest) {
			this._loadDrugs(true);
		}
	};

	componentWillUnmount = () => {

		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}

		if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout);
		}

		this._removeScrollListener();
	};


	refresh = () => {
		if (!this.pendingRequest && !this.state.loading && !this.state.loadingMore) {
			this.refreshingFromUpdate = true;
			const scrollPosition = this.scrollContainerRef.current ? this.scrollContainerRef.current.scrollTop : 0;
			this.savedScrollPosition = scrollPosition;
			this._loadDrugs(true);
		}
	};

	clearSearch = () => {
		this.setState({ search: '', currentPage: 1, drugs: [] }, () => {
			this._loadDrugs(true);
		});
	};

	_loadDrugs = async (reset = false) => {
		const { currentPage, search, sortConfig, loading, loadingMore, drugs } = this.state;
		const { pageSize, filter = {} } = this.props;
		if(this.pendingRequest)return;

		if (loading || loadingMore) {
			return;
		}
		

		const requestId = ++this.currentRequestId;
		

		const apiOrderBy = this.VALID_ORDER_BY_OPTIONS[sortConfig.key] || 'drug.type';


		if (reset) {
			// this.setState({ loading: true });
		} else {
			this.setState({ loadingMore: true });
		}
		
		try {
			const requestFilter = {
				...filter,
				page: currentPage,
				limit: pageSize,
				search: search,
				order_by: apiOrderBy,
				order_by_direction: sortConfig.direction
			};
			
			this.pendingRequest = mainAPI.drug.paginated(requestFilter);
			const response = await this.pendingRequest;
			this.pendingRequest = null;


			if (requestId !== this.currentRequestId) {
				return;
			}
			
			if (!response) {
				this.setState({
					drugs: reset ? [] : drugs,
					totalCount: 0,
					totalPages: 1,
					hasMore: false,
					loading: false,
					loadingMore: false
				});
				return;
			}
			

			const newDrugs = Array.isArray(response) ? response.filter(drug => drug != null) : [];
			

			const updatedDrugs = reset ? newDrugs : [...drugs, ...newDrugs];
			

			const hasMore = newDrugs.length === pageSize;

			this.setState({
				drugs: updatedDrugs,
				totalCount: updatedDrugs.length,
				totalPages: Math.ceil(updatedDrugs.length / pageSize),
				hasMore: hasMore,
				loading: false,
				loadingMore: false
			}, () => {

			if (reset && updatedDrugs.length > 0) {
				setTimeout(() => {
					this._setupScrollListener();
				}, 100);
			}
			});
		} catch (error) {

			if (requestId === this.currentRequestId) {
				console.error('Error loading drugs:', error);
				this.setState({ 
					drugs: reset ? [] : drugs,
					totalCount: 0,
					totalPages: 1,
					hasMore: false,
					loading: false,
					loadingMore: false
				});
			}
		}
	};

	_searchChange = (search) => {
		this.setState({ search, currentPage: 1, drugs: [] }, () => {

			clearTimeout(this.searchTimeout);
			this.searchTimeout = setTimeout(() => {
				this._loadDrugs(true);
			}, 300);
		});
	};

	_navigateToDrugDetailsPage = (drug) => {
		if (!drug || !drug.id) {
			console.warn('Cannot navigate: drug or drug.id is null/undefined');
			return;
		}
		history.navigate('/drug/' + drug.id);
	};

	_showCreateModal = () => {
		document.querySelector('html').scrollTo({ top: 0, behavior: 'smooth' });
		this.setState({
			create: true
		});
	};

	_closeCreateModal = () => {
		this.setState({ create: false });
	};

	_setupScrollListener = () => {
		this.scrollHandler = this._debounceScroll.bind(this);

		if (this.scrollContainerRef.current) {
			this.scrollContainerRef.current.addEventListener('scroll', this.scrollHandler, { passive: true });
			

			if (this.savedScrollPosition === undefined) {
				setTimeout(() => {
					if (this.scrollContainerRef.current) {
						this.scrollContainerRef.current.scrollTop = 1;
						setTimeout(() => {
							if (this.scrollContainerRef.current) {
								this.scrollContainerRef.current.scrollTop = 0;
							}
						}, 500);
					}
				}, 1000);
			} else {
				setTimeout(() => {
					if (this.scrollContainerRef.current && this.savedScrollPosition !== undefined) {
						this.scrollContainerRef.current.scrollTop = this.savedScrollPosition;
						this.savedScrollPosition = undefined;
					}
				}, 100);
			}
		} else {
			setTimeout(() => {
				if (this.scrollContainerRef.current) {
					this.scrollContainerRef.current.addEventListener('scroll', this.scrollHandler, { passive: true });
				}
			}, 100);
		}
	};

	_debounceScroll = () => {

		if (this.scrollTimeout) {
			clearTimeout(this.scrollTimeout);
		}
		

		this.scrollTimeout = setTimeout(() => {
			this._handleScroll();
		}, 100);
	};

	_removeScrollListener = () => {
		if (this.scrollHandler && this.scrollContainerRef.current) {
			this.scrollContainerRef.current.removeEventListener('scroll', this.scrollHandler);
		}
	};

	_handleScroll = () => {
		const { loadingMore, hasMore, currentPage } = this.state;

		

		if (loadingMore || !hasMore) {

			return;
		}
		

		

		const scrollContainer = this.scrollContainerRef.current;
		if (!scrollContainer) {

			return;
		}
		

		const scrollTop = scrollContainer.scrollTop;
		const scrollHeight = scrollContainer.scrollHeight;
		const clientHeight = scrollContainer.clientHeight;



		if (scrollHeight > clientHeight && scrollTop + clientHeight >= scrollHeight - 100) {


			this.setState({ currentPage: currentPage + 1 }, () => {
				this._loadDrugs(false);
			});
		}
	};

	_formatDrugsForTable = () => {
		const { showUnit, addMoreMode, drugOrderFormId, useDrugOrderFormColumns } = this.props;
		const { drugs } = this.state;


		if (!Array.isArray(drugs) || drugs.length === 0) {
			return [];
		}

		return drugs.map((drug, index) => {

			if (!drug) {
				return null;
			}

			const expiryDate = drug.expiration_date ? utils.server_to_client_date(drug.expiration_date) : null;
			const expiryDisplay = (expiryDate && utils.is_date(expiryDate)) ? utils.display_date(expiryDate) : '';

			const isChecked = addMoreMode && drug.drug_order_form_id == drugOrderFormId;

			let rowData = [
				{ column: "Type", value: drug.drug_type__name || '' },
				{ column: "Code", value: drug.barcode_id || '' },
				{ column: "Unit", value: drug.unit__name || '' },
				{ column: "Lot", value: drug.lot_number || '' }
			];

			if (useDrugOrderFormColumns) {
				const createdOnDate = drug.created_on ? utils.server_to_client_datetime(drug.created_on) : null;
				const createdOnDisplay = createdOnDate ? utils.display_actual_datetime(createdOnDate) : '';
				rowData.push(
					{ column: "Created On", value: createdOnDisplay, children: createdOnDisplay },
					{ column: "NDC Barcode", value: drug.ndc_barcode || '' }
				);
			} else {
				const lastCheckedDate = drug.last_checked_on ? utils.server_to_client_date(drug.last_checked_on) : null;
				const lastCheckedDisplay = lastCheckedDate ? utils.display_date(utils.server_to_client_datetime(drug.last_checked_on)) : '';
				rowData.push(
					{ column: "Last Check", value: lastCheckedDisplay, children: lastCheckedDisplay },
					{ column: "Checked By", value: drug.checked_by_name || '' }
				);
			}

			rowData.push({ column: "Expires On", value: expiryDisplay, children: expiryDisplay });

			return {
				data: rowData,
				drug: drug,
				isChecked: isChecked,
				onClick: () => {
					if (!addMoreMode) {
						this._navigateToDrugDetailsPage(drug);
					}
				}
			};
		}).filter(row => row !== null);
	};


	_getColumnWidths = () => {
		const { addMoreMode, useDrugOrderFormColumns } = this.props;
		const baseWidths = useDrugOrderFormColumns ? {
			'Type': '20%',
			'Code': '15%',
			'Unit': '15%',
			'Lot': '15%',
			'Created On': '15%',
			'NDC Barcode': '15%',
			'Expires On': '15%'
		} : {
			'Type': '20%',
			'Code': '15%',
			'Unit': '15%',
			'Lot': '15%',
			'Last Check': '15%',
			'Checked By': '15%',
			'Expires On': '15%'
		};

		if (addMoreMode) {
			return {
				'': '5%',
				...baseWidths
			};
		}

		return baseWidths;
	};

	_renderSortableTableHeader = (tableData) => {
		const { addMoreMode, onDrugCheckboxChange, useDrugOrderFormColumns } = this.props;
		let defaultHeaders = useDrugOrderFormColumns 
			? ['Type', 'Code', 'Unit', 'Lot', 'Created On', 'NDC Barcode', 'Expires On']
			: ['Type', 'Code', 'Unit', 'Lot', 'Last Check', 'Checked By', 'Expires On'];
		
		const headers = tableData && tableData.length > 0
			? tableData[0].data.map(r => r.column)
			: defaultHeaders;
		
		if (addMoreMode) {
			headers.unshift('');
		}
		
		const sortOptions = this._getSortTableOptions();
		const sortConfig = sortOptions.loadSortConfig();
		const columnWidths = this._getColumnWidths();
		
		const allChecked = addMoreMode && tableData && tableData.length > 0
			? tableData.every(row => row.isChecked)
			: false;
		
		const someChecked = addMoreMode && tableData && tableData.length > 0
			? tableData.some(row => row.isChecked)
			: false;
		
		const handleSelectAll = (checked) => {
			if (onDrugCheckboxChange && tableData) {
				tableData.forEach(row => {
					if (row.drug && row.isChecked !== checked) {
						onDrugCheckboxChange(row.drug, checked);
					}
				});
			}
		};
		
		const renderHeader = (header, index) => {
			if (addMoreMode && index === 0) {
				return (
					<TableCell 
						key={index}
						style={{ width: columnWidths[''] || '5%' }}
					>
						<CheckBox
							value={allChecked}
							onChange={handleSelectAll}
						/>
					</TableCell>
				);
			}
			
			return (
				<TableCell 
					key={index}
					style={{ width: columnWidths[header] || 'auto' }}
				>
					<TableSortLabel
						active={sortConfig.key === header}
						direction={sortConfig.key === header ? sortConfig.direction : 'asc'}
						onClick={() => sortOptions.onSortConfigSet({
							key: header,
							direction: sortConfig.key === header && sortConfig.direction === 'asc' ? 'desc' : 'asc'
						})}
					>
						<Label black bold>{header}</Label>
					</TableSortLabel>
				</TableCell>
			);
		};

		return (
			<Table>
				<TableHead>
					<TableRow>{headers.map(renderHeader)}</TableRow>
				</TableHead>
			</Table>
		);
	};

	_renderSortableTableBody = (tableData, loading) => {
		if (!tableData || tableData.length === 0) return null;
		
		const { addMoreMode, onDrugCheckboxChange } = this.props;
		const headers = tableData[0].data.map(r => r.column);
		const columnWidths = this._getColumnWidths();
		
		const renderRow = (row = {}, index) => {
			const { data: rowObjects = [], onClick = (() => {}), drug, isChecked } = row;
			const values = headers.map(header => {
				const cell = rowObjects.find(d => d.column === header) || {};
				const { value, children } = cell;
				return children ? children : value;
			});
			
			const rowKey = drug && drug.barcode_id ? drug.barcode_id : index;
			
			return (
				<TableRow onClick={onClick} key={rowKey}>
					{addMoreMode && (
						<TableCell 
							key="checkbox"
							style={{ width: columnWidths[''] || '5%' }}
							onClick={(e) => {
								e.stopPropagation();
							}}
						>
							<CheckBox
								forceValue={!!isChecked}
								onChange={(checked) => {
									if (onDrugCheckboxChange && drug) {
										onDrugCheckboxChange(drug, checked);
									}
								}}
							/>
						</TableCell>
					)}
					{values.map((value, i) => (
						<TableCell 
							key={i}
							style={{ width: columnWidths[headers[i]] || 'auto' }}
						>
							{value}
						</TableCell>
					))}
				</TableRow>
			);
		};

		return (
			<div 
				ref={this.scrollContainerRef}
				className="drug-table-body-container"
			>
				<Table>
					<TableBody>
						{tableData.map(renderRow)}
					</TableBody>
				</Table>
				{this._renderInfiniteScrollIndicator(loading)}
			</div>
		);
	};

	_renderInfiniteScrollIndicator = (loading) => {
		const { loadingMore, hasMore, drugs } = this.state;
		if(loading){
			return <div className="infinite-scroll-loading">
				Loading...
			</div>
		}
		if (loadingMore) {
			return (
				<div className="infinite-scroll-loading">
					Loading more drugs...
				</div>
			);
		}
		
		if (!hasMore && drugs.length > 0) {
			return (
				<div className="infinite-scroll-end">
					Nothing more to load
				</div>
			);
		}
		
		return null;
	};
	renderCOunt = 0;

	render() {
		console.log('DrugsPaginatedCard.render', this.renderCOunt++);
		const { create, loading, drugs } = this.state;
		const { title, displayNewDrugButton, showUnit } = this.props;
		
		const tableData = this._formatDrugsForTable();
		const hasData = Array.isArray(drugs) && drugs.length > 0;

		return (
			<Card className={'g-drugs-paginated-card'}>
				<div className="top-of-card">
					<CardHeader>{title || 'Drugs (Infinite Scroll)'}</CardHeader>
					<div className="top-of-card-right">
						<Input
							tabIndex={create ? -1 : 0}
							iconName="icon-search"
							placeholder="Search Type, Lot, Code or Checked By"
							value={this.state.search}
							onChange={this._searchChange}
						/>
					</div>
					{displayNewDrugButton && (
						<Button 
							onClick={this._showCreateModal} 
							className="top-of-card-right-button" 
							color="white" 
							bg="blue"
						>
							+ New Drug
						</Button>
					)}
					{this.props.children}
				</div>
				{create && <CreateDrugModal onClose={this._closeCreateModal} />}
					<div className="drug-table-wrapper">
						{this._renderSortableTableHeader(tableData)}
						{hasData && (
							this._renderSortableTableBody(tableData, loading)
						)}
					</div>

			</Card>
		);
	}
}

export default DrugsPaginatedCard;



// WEBPACK FOOTER //
// ./src/cards/drugPaginatedCard/DrugsPaginatedCard.jsx